import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToggleButton } from '@component/ToggleButton';
import { Dropdown, DropdownArea } from '@component/Dropdown';
import { ToggleButtonArea } from '@component/ToggleButtonArea';
import { useMediaDesktop } from '@app/react/common/useMedia';
import { useOrderPathParams } from '@app/react/contexts/useOrderPathParams';
import { isFeatherNone } from '@app/react/common/isFeatherNone';
import { MAKIWARA, MAKIWARA_THREAD_MODE } from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';
import {
    MAKIWARA_THREAD_MODE_B,
    MAKIWARA_THREAD_MODE_C,
} from '@app/react/const/variables';
import { partsSelectActions } from '@app/react/action';

const selectIsFeather = (state: AppState): boolean => isFeatherNone(state.customize.feather);

const option1 = [
    { label: 'オプション1：ツヤあり', value: 'true' },
    { label: 'オプション1：ツヤなし', value: 'false' },
];

const option2 = [
    { label: 'オプション2：末矧あり', value: MAKIWARA_THREAD_MODE_C },
    { label: 'オプション2：末矧なし', value: MAKIWARA_THREAD_MODE_B },
];

const option11 = [
    { displayName: 'ツヤあり', value: true },
    { displayName: 'ツヤなし', value: false },
];

type Opt22 = Array<{ displayName: string, value: MAKIWARA_THREAD_MODE }>;
const option22: Opt22 = [
    { displayName: '末矧あり', value: MAKIWARA_THREAD_MODE_C },
    { displayName: '末矧なし', value: MAKIWARA_THREAD_MODE_B },
];

const OrderOption1DropdownContainer = () => {
    const dispatch = useDispatch();
    const threadMatte = useSelector<AppState, boolean>(
        (state) => state.customize.threadGloss,
    );
    const onChange: React.ChangeEventHandler<HTMLSelectElement> = useCallback(
        (event) => {
            const gloss = /true/i.test(event.target.value);
            dispatch(partsSelectActions.threadGloss({ gloss }));
        },
        [dispatch],
    );

    return (
        <Dropdown
            className="order-option-dropdown--dropdown"
            items={option1}
            value={threadMatte.toString()}
            onChange={onChange}
        />
    );
};

const OrderOption2DropdownContainer = () => {
    const dispatch = useDispatch();
    const threadMode = useSelector<AppState, MAKIWARA_THREAD_MODE>(
        (state) => state.customize.threadMode,
    );
    const onChange: React.ChangeEventHandler<HTMLSelectElement> = useCallback(
        (event) => {
            const mode = event.target.value as MAKIWARA_THREAD_MODE;
            dispatch(partsSelectActions.threadMode({ mode }));
        },
        [dispatch],
    );

    return (
        <Dropdown
            className="order-option-dropdown--dropdown"
            items={option2}
            value={threadMode}
            onChange={onChange}
        />
    );
};

const OrderOption1ToggleContainer = () => {
    const dispatch = useDispatch();
    const threadMatte = useSelector<AppState, boolean>(
        (state) => state.customize.threadGloss,
    );
    const onChange = useCallback(
        (value: boolean) => {
            dispatch(partsSelectActions.threadGloss({ gloss: value }));
        },
        [dispatch],
    );

    return (
        <ToggleButton
            value={threadMatte}
            wrapperClassName="order-option-toggle--toggle-wrapper"
            onChange={onChange}
            groupOptions={option11}
            label="オプション1"
        />
    );
};

const OrderOption2ToggleContainer = () => {
    const dispatch = useDispatch();
    const threadMode = useSelector<AppState, MAKIWARA_THREAD_MODE>(
        (state) => state.customize.threadMode,
    );
    const onChange = useCallback(
        (value: MAKIWARA_THREAD_MODE) => {
            dispatch(partsSelectActions.threadMode({ mode: value }));
        },
        [dispatch],
    );

    return (
        <ToggleButton
            value={threadMode}
            wrapperClassName="order-option-toggle--toggle-wrapper"
            onChange={onChange}
            groupOptions={option22}
            label="オプション2"
        />
    );
};

export const OrderOptionContainer: FC = () => {
    const isDesktop = useMediaDesktop();
    const { arrowType } = useOrderPathParams();
    const existFeather = useSelector<AppState, boolean>(selectIsFeather);
    const isMakiwara = arrowType === MAKIWARA && existFeather;

    if (isDesktop) {
        return (
            <ToggleButtonArea className="order-option-toggle--area">
                <OrderOption1ToggleContainer />
                {isMakiwara && <OrderOption2ToggleContainer />}
            </ToggleButtonArea>
        );
    }

    return (
        <DropdownArea className="order-option-dropdown--area">
            <OrderOption1DropdownContainer />
            {isMakiwara && <OrderOption2DropdownContainer />}
        </DropdownArea>
    );
};
